import { useInfiniteQuery, type QueryKey } from '@tanstack/react-query';
import type { Paged } from './api';

/**
 * SAYFALANMIS LISTE — dort ekranin da kullandigi tek kalip.
 *
 * SAYFALAMA `hasMore` UZERINDEN yurur: liste sozlesmesinde `total` YOK, yani
 * "25 / 4000" gibi bir sayac cizilemez ve son sayfa numarasi hesaplanamaz.
 *
 * `snapshotAt` ILK SAYFADAN ALINIP GERI GONDERILIR. Aksi halde bu bolgede
 * ozellikle sik olan bir sey — liste acikken yeni bir kayit yazilmasi — pencereyi
 * kaydirir ve ayni satir iki sayfada birden gorunur (ya da bir satir hic
 * gorunmez). Denetim kaydinda bu neredeyse kesin: her yonetici islemi bir satir
 * ekliyor.
 */
export type PageParam = { offset: number; snapshotAt: string | null };

export const FIRST_PAGE: PageParam = { offset: 0, snapshotAt: null };

export const usePagedQuery = <T>(
  queryKey: QueryKey,
  fetchPage: (param: PageParam) => Promise<Paged<T>>,
) =>
  useInfiniteQuery<Paged<T>, Error, { pages: Paged<T>[] }, QueryKey, PageParam>({
    queryKey,
    queryFn: ({ pageParam }) => fetchPage(pageParam),
    initialPageParam: FIRST_PAGE,
    getNextPageParam: (lastPage) =>
      lastPage.page.hasMore
        ? {
            offset: lastPage.page.offset + lastPage.page.returned,
            snapshotAt: lastPage.page.snapshotAt,
          }
        : undefined,
  });

/** Sayfalari tek listeye duzler. */
export const flattenPages = <T>(data: { pages: Paged<T>[] } | undefined): T[] =>
  (data?.pages ?? []).flatMap((page) => page.items);
